import { styled } from '../../../utils/styled';
import { propStyles } from '../../../utils/propStyles';
const StyledComponent = styled<any, any>('label', 'label', 'autocomplete')`
    ${propStyles};
`;
StyledComponent.defaultProps = {
    marginX: 'xs',
};
export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Autocomplete/StyledComponents/Label.tsx